import pm from './pm'
import purchase from './purchase'
import order from './order'
import mall from './mall'
import sales from './sales'
import statement from './statement'
import statistics from './statistics'
import collect from './collect'
import account from './account'
import secondhand from './secondhand'
import report from './report'
import information from './information'
import push from './push'
import inputInvoice from './inputInvoice'
import outputInvoice from './outputInvoice'
import salesContracts from './salesContracts'

export default {
  pm,
  purchase,
  order,
  mall,
  sales,
  statement,
  statistics,
  collect,
  account,
  secondhand,
  report,
  information,
  push,
  inputInvoice,
  outputInvoice,
  salesContracts
}



// WEBPACK FOOTER //
// ./src/router/routes/v5/index.js